import { render } from "./TwoFactor.vue?vue&type=template&id=d34f050e&scoped=true"
import script from "./TwoFactor.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./TwoFactor.vue?vue&type=script&charset=utf-8&lang=js"

import "./TwoFactor.vue?vue&type=style&index=0&id=d34f050e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d34f050e"]])

export default __exports__